import { Backdrop, Modal, Rating } from "@mui/material";
import { DownloadGuide } from "@unisearch/common";
import {
  getAssets,
  isUniCompare,
  isUniFavorite,
  upperFirstLetter,
} from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { useSystemActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { BiLinkExternal } from "react-icons/bi";
import { FaMapMarkerAlt, FaUniversity } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { RiBook2Fill } from "react-icons/ri";
import { useRecoilValue } from "recoil";
import styles from "./uni_brief.module.scss";
import GuestFormReview from "./uni_reviews/components/guest_form_review";
import RegisterFormReview from "./uni_reviews/components/register_form_review";
const FavoriteAction = dynamic(
  () => import("@unisearch/common/ui_element/actions/favorite"),
  { ssr: false }
);

const CompareAction = dynamic(
  () => import("@unisearch/common/ui_element/actions/compare"),
  { ssr: false }
);

const ReviewOption = ({
  value,
  uniProfileData,
  setModal,
  getData,
  existingComment,
  onEdit,
  getComment,
}) => {
  switch (value) {
    case 0:
      return (
        <GuestFormReview
          getData={getData}
          setModal={setModal}
          uniProfileData={uniProfileData}
        />
      );

    case 1:
      return (
        <RegisterFormReview
          setModal={setModal}
          uniProfileData={uniProfileData}
          getData={getData}
          onEdit={onEdit}
          existingComment={existingComment}
          getComment={getComment}
        />
      );
  }
};

export const UniBrief = ({ uniProfileData, customClasses }) => {
  const profileInfo = useRecoilValue(authAtom);
  const router = useRouter();
  const [modal, setModal] = useState(false);
  const [value, setValue] = useState(0);
  const [existingComment, setExistingComment] = useState({});
  const [onEdit, setOnEdit] = useState(false);
  const systemActions = useSystemActions();

  // get existing comment
  const getComment = async () => {
    await API.get(
      `/public/university-review/check/${uniProfileData?.universitySlug}`
    ).then((res) => {
      if (!res.error && res.data) {
        const { data } = res;
        setExistingComment(data);
        setOnEdit(true);
      } else {
        setExistingComment({});
        setOnEdit(false);
      }
    });
  };

  useEffect(() => {
    if (uniProfileData?.universitySlug && profileInfo && modal) {
      getComment();
    }
  }, [uniProfileData?.universitySlug, profileInfo, modal]);

  useEffect(() => {
    if (profileInfo) {
      setValue(1);
    } else {
      setValue(0);
    }
  }, [profileInfo]);

  const getData = () => {};

  return (
    <section
      className={`${styles.section_uni_brief} ${
        customClasses?.root ? customClasses?.root : ""
      }`}
    >
      <div className="container">
        <div className={styles.brief_wrapper}>
          <div className={styles.brief_left_wrapper}>
            <div className={styles.uni_logo_wrapper}>
              <img
                src={
                  uniProfileData?.logosrc ||
                  getAssets("assets/images/uni-profile/logo-placeholder.png")
                }
                alt="University Logo"
              />
            </div>

            <div className={styles.uni_brief_info}>
              <h1>{uniProfileData?.universityName}</h1>
              <ul>
                <li>
                  <FaUniversity />
                  <span>
                    {uniProfileData?.universityType
                      ? upperFirstLetter(uniProfileData.universityType)
                      : ""}{" "}
                    University, Estd {uniProfileData?.estd}
                  </span>
                </li>

                <li>
                  <FaMapMarkerAlt />
                  <span>
                    {uniProfileData?.cityName}, {uniProfileData?.stateName}
                  </span>
                </li>
                <li>
                  <RiBook2Fill />
                  <span>
                    {uniProfileData?.totalCourse}{" "}
                    {uniProfileData?.totalCourse > 1 ? "Courses" : "Course"}
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className={styles.brief_right_wrapper}>
            <div className={styles.rating_wrapper}>
              {uniProfileData?.totalRating && (
                <div className={styles.info_rating_number}>
                  {uniProfileData?.finalRating} ({uniProfileData?.totalRating})
                </div>
              )}
              {uniProfileData?.finalRating && (
                <div
                  className={styles.info_rating_stars}
                  onClick={() => {
                    setModal(true);
                  }}
                >
                  <Rating
                    name="rating-read"
                    value={
                      uniProfileData?.finalRating &&
                      parseInt(uniProfileData?.finalRating)
                    }
                    readOnly
                  />
                </div>
              )}
            </div>

            <a
              rel="nofollow"
              className={styles.uni_web_link}
              href={uniProfileData?.website}
              target="_blank"
            >
              <span>International student website</span>
              <BiLinkExternal />
            </a>

            <div className={styles.compare_wrapper}>
              <FavoriteAction
                referance="university"
                referanceId={parseInt(uniProfileData.universityId)}
                is_favorite={isUniFavorite(
                  profileInfo,
                  uniProfileData.universityId
                )}
              />
              <CompareAction
                referance="university"
                referanceId={parseInt(uniProfileData.universityId)}
                is_compared={isUniCompare(
                  profileInfo,
                  uniProfileData.universityId
                )}
              />
              {/* when download button click plz warning if user not logged in */}
              {uniProfileData && uniProfileData?.documentInfo && (
                <DownloadGuide
                  customClasses={{ root: "btn-bg" }}
                  fileSrc={uniProfileData?.documentInfo?.documentSrc}
                  documentId={uniProfileData?.documentInfo?.documentId}
                  documentType="prospectus"
                  universityId={parseInt(uniProfileData.universityId)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={modal}
        onClose={() => {
          setModal(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="modal md">
          <div className={`modal_head ${styles.modal_header}`}>
            <h4 className={`${styles.title} modal_title`}></h4>
            <button
              className={`cross_icon ${styles.cross_action}`}
              onClick={() => {
                setModal(false);
              }}
            >
              <FiX />
            </button>
          </div>

          <div className={`${styles.modal_body} modal_body`}>
            <h4 className={styles.modal_title}>Write a Review</h4>
            <p className={styles.modal_description}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim
              odio dui, felis ultricies. Scelerisque quam tristique faucibus
              cras. Malesuada lobortis habitasse et enim vitae lectus tellus. Et
              volutpat hendrerit iaculis non in adipiscing tincidunt ut.
            </p>
            {!profileInfo && (
              <div className={styles.action_btn}>
                <button
                  onClick={() => {
                    setValue(0);
                  }}
                  className={value === 0 && styles.active_btn}
                >
                  Guest User
                </button>
                <button
                  onClick={() => {
                    setValue(1);
                  }}
                  className={value === 1 && styles.active_btn}
                >
                  Register User
                </button>
              </div>
            )}
            <ReviewOption
              setModal={setModal}
              uniProfileData={uniProfileData}
              value={value}
              getData={getData}
              existingComment={existingComment}
              onEdit={onEdit}
              getComment={getComment}
            />
          </div>
        </div>
      </Modal>
    </section>
  );
};

export default UniBrief;
